const aboutMe = {
  namespaced: true,
  state: () => ({
    about:
      "I'm a Web Developer focused on building responsive and interactive user interfaces with React.js and Vue.js. Check out my project portfolio and online resume.",
    whatIDo:
      "I build websites and web applications using React.js and Vue.js. I write clean code that's easy to maintain and understand. I work with JavaScript, React.js, Material UI, and Vue.js to create websites that look good and work smoothly. I enjoy solving problems and learning new things about web development. Here's what I can do - want to see my work?",
    technologies: [
      {
        name: "HTML",
        img: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/html5/html5-original.svg",
        description:
          "I use HTML to structure content on the web. It's the backbone of every webpage.",
      },
      {
        name: "CSS",
        img: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/css3/css3-original.svg",
        description:
          "I leverage CSS to style and make websites visually appealing, ensuring responsiveness and clean design.",
      },
      {
        name: "JavaScript",
        img: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/javascript/javascript-original.svg",
        description:
          "I use JavaScript to create interactive and dynamic web applications, handling client-side logic and user interactions.",
      },
      {
        name: "React.js",
        img: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/react/react-original.svg",
        description:
          "I use React.js to build modern, component-based user interfaces with Material UI for beautiful and responsive designs.",
      },
      {
        name: "Material UI",
        img: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/materialui/materialui-original.svg",
        description:
          "I leverage Material UI to create consistent, beautiful, and responsive user interfaces in React applications.",
      },
      {
        name: "Vue.js",
        img: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/vuejs/vuejs-original.svg",
        description:
          "I use Vue.js for building reactive, user-friendly front-end applications and single-page apps (SPA).",
      },
      {
        name: "Vuetify",
        img: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/vuetify/vuetify-original.svg",
        description:
          "I leverage Vuetify to create beautiful Material Design interfaces in Vue.js applications with its comprehensive component library.",
      },
      {
        name: "Bootstrap",
        img: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/bootstrap/bootstrap-original.svg",
        description:
          "I use Bootstrap to rapidly build responsive and modern user interfaces with ready-made components.",
      },
      {
        name: "PHP",
        img: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/php/php-original.svg",
        description:
          "PHP is one of the core languages I use for backend development. I utilize it to create dynamic, data-driven websites.",
      },
      {
        name: "Laravel",
        img: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/laravel/laravel-line.svg",
        description:
          "Laravel is my go-to framework for PHP. It enables me to develop clean, scalable, and efficient applications.",
      },
      {
        name: "MySQL",
        img: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/mysql/mysql-original.svg",
        description:
          "MySQL is the relational database I use to efficiently store and retrieve data for my applications.",
      },
      {
        name: "Git",
        img: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/git/git-original.svg",
        description:
          "I use Git for version control to track changes, collaborate with teams, and manage project history.",
      },
      {
        name: "Postman",
        img: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/postman/postman-original.svg",
        description:
          "I use Postman for API testing, ensuring smooth interactions and debugging between systems.",
      },
    ],
  }),
};

export default aboutMe;
